import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'

import LoginLayout from '@/views/auth/LoginLayout.vue'
import LoginView from '@/views/auth/LoginView.vue'

import AppLayout from '@/views/app/AppLayout.vue'
import PendentsView from '@/views/app/PendentsView.vue'
import RequestsView from '@/views/app/RequestsView.vue'
import ProductsView from '@/views/app/ProductsView.vue'
import CategoriesView from '@/views/app/CategoriesView.vue'
import UsersView from '@/views/app/UsersView.vue'
import PlacesView from '@/views/app/PlacesView.vue'
import ReportsView from '@/views/app/ReportsView.vue'

import ProfileView from '@/views/app/ProfileView.vue'
import ProductView from '@/views/app/Views/ProductView.vue'
import CategoryView from '@/views/app/Views/CategoryView.vue'
import RequestView from '@/views/app/Views/RequestView.vue'
import UserView from '@/views/app/Views/UserView.vue'
import PlaceView from '@/views/app/Views/PlaceView.vue'
import EventsView from '@/views/app/events/EventsView.vue'
import EventView from '@/views/app/events/EventView.vue'
import CompaniesView from '@/views/app/travel/companies/CompaniesView.vue'
import CompanyView from '@/views/app/travel/companies/CompanyView.vue'
import TripsView from '@/views/app/travel/TripsView.vue'
import TripView from '@/views/app/travel/TripView.vue'
import LayoutView from '@/views/companies/LayoutView.vue'
import CompanyInfoView from '@/views/companies/CompanyInfoView.vue'
import TravelListView from '@/views/companies/TravelListView.vue'
import TravelInfoVIew from '@/views/companies/TravelInfoVIew.vue'
import VideosView from '@/views/app/VideosView.vue'
import StoresView from '@/views/app/StoresView.vue'
import StoreView from '@/views/app/Views/StoreView.vue'
import MessageView from '@/views/app/MessageView.vue'
import WithdrawsView from '@/views/app/WithdrawsView.vue'
import AffiliatesView from '@/views/app/AffiliatesView.vue'
import AdBannersView from '@/views/app/adBannersView.vue'


const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Login',
        redirect: '/login',
        component: LoginLayout,
        children: [
            {
                path: '/login',
                name: 'Iniciar Sessão',
                component: LoginView
            },
        ]
    },
    {
        path: '/companies-dashboard',
        name: 'CompaniesDashboard',
        redirect: '/companies-dashboard',
        component: LayoutView,
        children: [
            {
                path: '/companies-dashboard',
                name: 'Info',
                component: CompanyInfoView
            },
            {
                path: '/companies-dashboard/travel',
                name: 'Travel List',
                component: TravelListView
            },
            {
                path: '/companies-dashboard/travel/:id',
                name: 'Travel Info',
                component: TravelInfoVIew
            },
        ]
    },
    {
        path: '/home',
        name: 'Layout',
        redirect: '/dashboard',
        component: AppLayout,
        meta: {
            requiresAuth: true
        },
        children: [
            // gets e lists
            {
                path: '/dashboard',
                name: 'DashBoard',
                component: PendentsView
            },
            {
                path: '/requests',
                name: 'Pedidos atendidos',
                component: RequestsView
            },
            {
                path: '/products',
                name: 'Produtos cadastrados',
                component: ProductsView
            },
            {
                path: '/stores',
                name: 'Lojas cadastradas',
                component: StoresView
            },
            {
                path: '/categories',
                name: 'Categorias',
                component: CategoriesView
            },
            {
                path: '/videos',
                name: 'Videos',
                component: VideosView
            },
            {
                path: '/users',
                name: 'Entregadores e administradores',
                component: UsersView
            },
            {
                path: '/places',
                name: 'Lugares',
                component: PlacesView
            },
            {
                path: '/reports',
                name: 'Relatórios',
                component: ReportsView
            },

            // updates e gets
            {
                path: '/profile',
                name: 'Minha conta',
                component: ProfileView
            },
            {
                path: '/products/:id',
                name: 'Produto',
                component: ProductView
            },
            {
                path: '/stores/:id',
                name: 'Loja',
                component: StoreView
            },
            {
                path: '/categories/:id',
                name: 'Categoria',
                component: CategoryView
            },
            {
                path: '/requests/:id',
                name: 'Pedido',
                component: RequestView
            },
            {
                path: '/users/:id',
                name: 'Vendedor ou administrador',
                component: UserView
            },
            {
                path: '/places/:id',
                name: 'Local Fisico',
                component: PlaceView
            },

            // Events
            {
                path: '/events',
                name: 'events',
                component: EventsView
            },
            {
                path: '/events/:id',
                name: 'event',
                component: EventView
            },

            // Companies
            {
                path: '/companies',
                name: 'Travel companies',
                component: CompaniesView
            },
            {
                path: '/companies/:id',
                name: 'Travel company',
                component: CompanyView
            },
            
            // Travel
            {
                path: '/travel',
                name: 'Travel',
                component: TripsView
            },
            {
                path: '/travel/:id',
                name: 'Trip ',
                component: TripView
            },

            // mensagem geral
            {
                path: '/message',
                name: 'message',
                component: MessageView
            },

            {
                path: '/affiliates',
                name: 'afiliados',
                component: AffiliatesView
            },
            {
                path: '/withdraws',
                name: 'levantamentos',
                component: WithdrawsView
            },

            {
                path: '/ad-banners',
                name: 'Banners',
                component: AdBannersView
            },
        ]
    }
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isLoggedIn = store.getters.isLoggedIn;
    localStorage.removeItem('redirect')
    
    to.name && (document.title = to.name.toString())
    if (requiresAuth && !isLoggedIn) {
        sessionStorage.setItem('redirect', from.path)
        next({ name: 'Login' }); 
    } else {
        next();
    }
});

export default router;
